import * as React from "react";
import { Customer } from "@testout/testout-commerce/models/commerce/Customer";
import { CustomerAddress } from "@testout/testout-commerce/models/commerce/CustomerAddress";
import LabelCtl from "./input/LabelCtl";
import CheckCtl from "./input/CheckCtl";
import LookupCtl from "./input/LookupCtl";
import CustomerAddressCtl from "./CustomerAddressCtl";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import Api from "./Api";

interface ICustomerProps {
    disabled?: boolean;
    isRequired?: boolean;
    customer: Customer;
    hsCompanyId?: number;
    onChange?: (customer: Customer) => void;
    onSelect?: (customer: Customer) => void;
    onSetErrorMessage?: (error: string) => void;
    className?: string;
    style?: React.CSSProperties;
}


export default class CustomerCtl extends React.PureComponent<ICustomerProps> {

    onCustomerSelected = async (value: string) => {
        let customer = await Api.get<Customer>(`/api/customers/${value}`);
        this.props.onSelect?.(customer);
    }

    onDoCustomerSearch = async (value: string, exact?: boolean): Promise<ListItem[]> => {
        return exact
            ? [await Api.get<ListItem>(`/api/customers/${value}/list-item`)]
            : await Api.get<ListItem[]>(`/api/customers/list-items?search=${encodeURIComponent(value)}`);
    }

    onCustomerNumberChange = async (value: string) => {
        let customer = await Api.get<Customer>(`/api/customers/${value}`);
        this.props.onChange?.(customer);
    }

    onIsStudentChange = (value: boolean) => {
        let customer = new Customer(this.props.customer);
        customer.isStudent = value;
        if (value === true) {
            customer.parentCustomerNumber = customer.customerNumber;
            customer.customerNumber = "";
        } else {
            customer.customerNumber = customer.parentCustomerNumber ?? "";
            customer.parentCustomerNumber = "";
        }
        this.props.onChange?.(customer);
    }

    onAddressChange = (address: CustomerAddress) => {
        let customer = new Customer(this.props.customer);
        customer.address = address;
        this.props.onChange?.(customer);
    }

    render() {
        let customerNumber = this.props.customer.isStudent ? this.props.customer.parentCustomerNumber : this.props.customer.customerNumber;
        return <React.Fragment>
                   <LabelCtl label="Customer">{this.props.isRequired && <span className="required">&nbsp;*</span>}
                       <LookupCtl placeholder="Search companies" disabled={this.props.disabled}
                                  value={customerNumber}
                                  onChange={this.onCustomerNumberChange}
                                  onSelect={this.onCustomerSelected}
                                  onSearch={this.onDoCustomerSearch}/>
                   </LabelCtl>

                   <LabelCtl label="Address" useDiv={true}>
                       <CheckCtl label="Is Student" className="check-right" disabled={this.props.disabled}
                                 value={this.props.customer.isStudent} onChange={this.onIsStudentChange}/>
                       <CustomerAddressCtl customerNumber={customerNumber} hsCompanyId={this.props.hsCompanyId}
                                           disabled={this.props.disabled} address={this.props.customer.address}
                                           onChange={this.onAddressChange} onSetErrorMessage={this.props.onSetErrorMessage} />
                   </LabelCtl>
               </React.Fragment>;
    }
}